module.exports = __webpack_public_path__ + "img/habeinleumi-large.bb709b24.svg";